import { render, staticRenderFns } from "./onewood.vue?vue&type=template&id=29a2ed7d&scoped=true&"
import script from "./onewood.vue?vue&type=script&lang=js&"
export * from "./onewood.vue?vue&type=script&lang=js&"
import style0 from "./onewood.vue?vue&type=style&index=0&id=29a2ed7d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a2ed7d",
  null
  
)

export default component.exports